import { render, staticRenderFns } from "./LoginFacebook.vue?vue&type=template&id=23b05d72&scoped=true"
import script from "./LoginFacebook.vue?vue&type=script&lang=js"
export * from "./LoginFacebook.vue?vue&type=script&lang=js"
import style0 from "./LoginFacebook.vue?vue&type=style&index=0&id=23b05d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b05d72",
  null
  
)

export default component.exports